import React from 'react';
import '../styles/Services.css';

const Services = () => {
  return (
    <div className="container services-section">
     
      
      <div className="services-grid">
        <div className="service-card">
          <div className="service-icon"><i className="fas fa-handshake"></i></div>
          <h3>2. Wide Partner Network</h3>
          <p>Partnered with top academies & grounds across Dubai.</p>
        </div>
        <div className="service-card">
          <div className="service-icon"><i className="fas fa-location-dot"></i></div>
          <h3>3. Location‑Based Search</h3>
          <p>Quickly find grounds near home, work, or training spots.</p>
        </div>
        <div className="service-card">
          <div className="service-icon"><i className="fas fa-bolt"></i></div>
          <h3>4. Instant Booking & Confirmation</h3>
          <p>Secure & fast — no calls, confirmation in seconds.</p>
        </div>
      </div>

      <div className="service5-block">
        <h3>⚽ 5. Booking for Teams, Events & Training</h3>
        <div className="booking-tags">
          <span className="tag">friendly matches</span>
          <span className="tag">team practice</span>
          <span className="tag">coaching / academy</span>
        </div>
      </div>

      <div className="dual-panel">
        <div className="panel">
          <i className="fas fa-building"></i>
          <h3>6. Support for ground owners</h3>
          <p>List your facility, increase visibility.</p>
        </div>
        <div className="panel">
          <i className="fas fa-headset"></i>
          <h3>7. Customer support</h3>
          <p>We're here to help with bookings & questions.</p>
        </div>
      </div>
    </div>
  );
};

export default Services;